import { slugify } from "./string";
import { LANG_ID_EN, URL_SUFFIX_EN, URL_SUFFIX_VI } from "./language";
import { ELanguage } from "@microfrontends/react-components";

export function buildSearchByLocationUrl(locationName, locationId, languageId) {
	const locationSlug = slugify(locationName)

	let url = '/#'
	if (languageId === LANG_ID_EN) {
		url = `/${locationSlug}-jobs-v${locationId}-${URL_SUFFIX_EN}`
	} else {
		url = `/viec-lam-tai-${locationSlug}-v${locationId}-${URL_SUFFIX_VI}`
	}

	return buildVNWUrlFromPath(url)
}

export function buildSearchByIndustryUrl(industryName, industryId, languageId) {
	const industrySlug = slugify(industryName)

	let url = '/#'
	if (languageId === LANG_ID_EN) {
		url = `/${industrySlug}-jobs-i${industryId}-${URL_SUFFIX_EN}`
	} else {
		url = `/viec-lam-${industrySlug}-i${industryId}-${URL_SUFFIX_VI}`
	}

	return buildVNWUrlFromPath(url)
}

export function buildVNWUrlFromPath(path) {
	return process.env.VNW_BASE_URL + path
}

export function assetUrl(path) {
	return process.env.APP_ASSET_URL + path
}

export function buildVNWScriptUrl(scriptName) {
	return `${process.env.VNW_BASE_URL}/js/${scriptName}.js?version=${process.env.VNW_BUILD_ID}`
}

export function buildJobUrl(jobId, alias, languageId, queryParams) {
	let queryString = ''
	if (!!queryParams) {
		queryString = buildQueryString(queryParams)
	}

	const baseJobUrl = `${process.env.VNW_BASE_URL}/${alias}-${jobId}-${languageId == LANG_ID_EN ? 'jd' : 'jv'}`

	return queryString != '' ? `${baseJobUrl}/?${queryString}` : baseJobUrl;
}

export function buildQueryString(params: any) {
	let queryString: any[] = []

	for (var key in params) {
		if (params.hasOwnProperty(key) && !!params[key]) {
			queryString.push(`${key}=${encodeURIComponent(params[key])}`)
		}
	}

	return queryString.length > 0 ? queryString.join('&') : ''
}


export function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	let results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function buildSkillUrl(title, language, utm = '') {
	let currentUTMSource = getUrlParameter('utm_source_navi');
	currentUTMSource = !!currentUTMSource ? '/?source=searchResults' : utm;
	return '/' + encodeURIComponent(title) + '-' + (language == 2 ? 'kw' : 'kv') + currentUTMSource;
}

export function buildLocationSearchPath(keyword, locationObj, language) {

	const encodedKeyword = encodeURIComponent(
		keyword.replace(/C\+\+|c\+\+/, 'C_plus_plus')
			.replace(/C#|c#/, 'C_sharp'))
		.replace(/' '+/, '-')
	const suffixPath = language == 2 ? 'en' : 'vn'
	const locationPrefix = language == 2 ? 'in' : 'tai'
	
	let locationSlug = ''
	let locationId = ''
	if (locationObj.length > 0) {
		locationObj.map((item, index) => {
			locationId += (index > 0 ? '.' : '') + item.id
			locationSlug += (index > 0 ? '-' : '') + slugify(item.name)
		})
	}
	return `/${encodedKeyword}+${locationPrefix}-${locationSlug}-v${locationId}-${suffixPath}`
}

export function buildSearchPath(inputKeyword, categoryObj: any = null, locationObj: any = null, languageId = 1) {
	let searchPath = '';
	const keyword = inputKeyword;
	const suffixPath = languageId == 2 ? 'en' : 'vn';
	const suffixOnlyKeyword = languageId == 2 ? 'kw' : 'kv';

	// Exceptional case: Only keyword provided
	if (keyword && !categoryObj && !locationObj) {
		return `/${encodeURIComponent(keyword)}-${suffixOnlyKeyword}`
	}

	let categoryId = -1
	let categorySlug = ''
	if (categoryObj) {
		categoryId = categoryObj.id
		categorySlug = slugify(categoryObj.name)
	}

	let locationId = ''
	let locationSlug = ''
	if (locationObj.length > 0) {
		locationObj.map((item, index) => {
			locationId += (index > 0 ? '.' : '') + item.id
			locationSlug += (index > 0 ? '-' : '') + slugify(item.name)
		})
	}

	const searchSlug = buildSearchSlugText(keyword, categorySlug, locationSlug, languageId);
	const searchCodeStr = buildSearchCode(categoryId, locationId);

	if (searchSlug !== '' && searchCodeStr !== '') {
		searchPath = `/${searchSlug}-${searchCodeStr}-${suffixPath}`
	}

	return searchPath
}

function buildSearchSlugText(keyword, categorySlug, locationSlug, language) {
	let slug = '';

	const categoryPrefix = language == 2 ? 'at' : 'nganh';
	const locationPrefix = language == 2 ? 'in' : 'tai';
	const noKeywordObject = language == 2 ? 'jobs' : 'viec-lam';

	if (keyword !== '') {
		let filterSlug = '';

		if (categorySlug !== '') {
			filterSlug += `${filterSlug !== '' ? '-' : ''}${categoryPrefix}-${categorySlug}`
		}

		if (locationSlug !== '') {
			filterSlug += `${filterSlug !== '' ? '-' : ''}${locationPrefix}-${locationSlug}`
		}

		slug += `${encodeURIComponent(keyword)}+${filterSlug}`
	} else {
		if (categorySlug !== '' && locationSlug !== '') {
			slug = `${language === 'en' ? '' : `${noKeywordObject}-`}${categorySlug}${language === 'en' ? `-${noKeywordObject}` : ''}-${locationPrefix}-${locationSlug}`
		} else {
			if (categorySlug !== '') {
				slug = `${language === 'en' ? '' : `${noKeywordObject}-`}${categorySlug}${language === 'en' ? `-${noKeywordObject}` : ''}`
			}

			if (locationSlug !== '') {
				slug = `${language === 'en' ? '' : `${noKeywordObject}-`}${locationSlug}${language === 'en' ? `-${noKeywordObject}` : ''}`
			}
		}
	}

	return slug
}

function buildSearchCode(categoryId, locationId) {
	const categoryCode = categoryId > 0 ? 'i' + categoryId : '';
	const locationCode = locationId !== 0 || locationId !== '' ? 'v' + locationId : '';

	return categoryCode + locationCode
}

export function encodeKeyword(rawKeyword) {
	var blackList = [{'regex': /C#/gi, 'replace': 'C_sharp'}, {
		'regex': /C\+\+/gi,
		'replace': 'C_plus_plus'
	}, {'regex': /[\[\]\\\/:~\^\?!()&><"'@%|{}`*#]/gi, 'replace': ' '}], regex, tempkeyword;
	for (var i in blackList) {
		rawKeyword = rawKeyword.replace(blackList[i].regex, blackList[i].replace);
	}
	do {
		tempkeyword = rawKeyword;
		rawKeyword = tempkeyword.replace("  ", " ")
	} while (tempkeyword != rawKeyword);
	rawKeyword = rawKeyword.trim();
	return rawKeyword.replace(/ /g, '-');
}

export const isRobot = (userAgent: string): boolean => {
	const botUserAgents = [
		'googlebot',
        'google-structured-data-testing-tool',
        'bingbot',
        'linkedinbot',
        'mediapartners-google',
        'apis-google',
        'feedfetcher-google',
        'googlebot-image',
        'storebot-google'
	]
	const currentUserAgent: string = userAgent.toLowerCase()
	
	return botUserAgents.some((item) => {
		return currentUserAgent.includes(item)
	})
}

export function buildCompanyUrl(companyId: number, companySlug: string, langCode: ELanguage) {
    const prefixPath = langCode === ELanguage.EN ? 'companies' : 'nha-tuyen-dung'
    return `/${prefixPath}/${companySlug}-c${companyId}`
}
